// Generated by GitHub Copilot
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

// Extend dayjs with plugins
dayjs.extend(relativeTime);

/**
 * Format a date string as a relative time string (e.g., "2 hours ago")
 * Uses dayjs with relativeTime plugin for consistency with the rest of the codebase
 * @param {string} dateString - ISO date string
 * @returns {string} - Formatted relative time string
 */
export const formatTimeAgo = (dateString) => {
  if (!dateString) return "Unknown";

  const date = dayjs(dateString);
  if (!date.isValid()) return "Unknown";

  return date.fromNow();
};
